/**
 * Stripe-provided "buttonTheme" variant for the ExpressCheckoutElement.
 * Apple/Google Pay each publish a light ("white") and dark ("black") button -
 * we pick whichever has enough contrast against the checkout background so
 * the official assets render as intended.
 *
 * Shared between CheckoutForm (standard individual checkout) and
 * SplitPayCaptainCheckout so wallet button styling stays consistent across
 * all paid-flow surfaces.
 */
export function getExpressButtonTheme(
  contentBoxStyle: 'white' | 'black' | 'transparent' | undefined,
  themeText: string | undefined,
): { applePay: 'black' | 'white' | 'white-outline'; googlePay: 'black' | 'white' } {
  // For the transparent case we inspect the page text colour - light text
  // means the page has a dark background, which pairs with the black buttons.
  if (contentBoxStyle === 'transparent' && themeText) {
    const rgb = parseInt(themeText.replace('#', ''), 16);
    const brightness = (((rgb >> 16) & 0xff) * 299 + ((rgb >> 8) & 0xff) * 587 + (rgb & 0xff) * 114) / 1000;
    const isLightText = brightness > 128;
    return isLightText
      ? { applePay: 'white', googlePay: 'white' }
      : { applePay: 'black', googlePay: 'black' };
  }
  if (contentBoxStyle === 'black') {
    return { applePay: 'white', googlePay: 'white' };
  }
  return { applePay: 'black', googlePay: 'black' };
}
